import React from 'react'
import { FaEdit, FaTrash } from 'react-icons/fa'
import { useDispatch } from 'react-redux';
import { displayRemoveAlert } from '../../../redux/slice/formUpdateSlice';
import { getImagePath } from '../../../utils/util';
import { useNavigate } from 'react-router-dom';

function LocationItem(props) {
  const dispatch = useDispatch();
  const navigate=useNavigate();
  const deleteItem = () => {

    dispatch(displayRemoveAlert({ displayRemove: true, formData: { item: props.result }, type: "banner" }));
  };

   const editItem=()=>{
      navigate("/addNewLocation",{state:{item:props}})
  }

  return (
    <>
      <tr>
        <td>{props.id}</td>

        <td>{props.result.name}</td>

        <td>{props.result.web_url}</td>

        <td><img src={getImagePath(props.result.image_path)} className="img-thumbnail" style={{ width: 75 }} /> </td>

        {/* <td>
          <div className="d-flex flex-row justify-content-center form-switch form-check">
            <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            checked
            />
          </div>
            </td> */}
        <td className="align-middle">
          <div className="d-flex justify-content-center">

            <span className="delete-icon-btn">
              <FaTrash onClick={deleteItem} />
            </span>
            <span className="edit-icon-btn" onClick={editItem}>
              <FaEdit />
            </span>
          </div>
        </td>

      </tr>
    </>
  )

}

export default LocationItem